export default [
  {
    name: "Campaigns",
    path: "/risk-engine/campaigns",
    component: () => import("@/modules/riskEngine/campaigns/pages/Campaigns"),
    meta: {
      ability: [
        {
          resource: "campaigns",
          actions: ["read"],
        },
      ],
    },
  },
  {
    name: "Campaigns View",
    path: "/risk-engine/campaigns/view/:id",
    component: () => import("@/modules/riskEngine/campaigns/pages/TabPage"),
    meta: {
      ability: [
        {
          resource: "campaigns/:id",
          actions: ["read"],
        },
      ],
    },
  },
];
